module.exports = __webpack_public_path__ + "img/circle-checkmark.bacf4ed7.svg";